import { FirmUnderwriterItem } from 'api/admin/types';

export function isUnderwriterLocked(underwriter: FirmUnderwriterItem): boolean {
  return underwriter.IsSelected === undefined;
}

export function buildInitialUnderwriterSelection(underwriters: FirmUnderwriterItem[]): Set<number> {
  return new Set(
    underwriters.filter((underwriter) => underwriter.IsSelected !== false).map((underwriter) => underwriter.Id),
  );
}

export function isUnderwriterChecked(underwriter: FirmUnderwriterItem, selectedIds: Set<number>): boolean {
  if (isUnderwriterLocked(underwriter)) {
    return true;
  }

  return selectedIds.has(underwriter.Id);
}

export function toggleUnderwriterSelection(underwriter: FirmUnderwriterItem, selectedIds: Set<number>): Set<number> {
  if (isUnderwriterLocked(underwriter)) {
    return selectedIds;
  }

  const nextSelectedIds = new Set(selectedIds);

  if (nextSelectedIds.has(underwriter.Id)) {
    nextSelectedIds.delete(underwriter.Id);
  } else {
    nextSelectedIds.add(underwriter.Id);
  }

  return nextSelectedIds;
}

export function getSelectableUnderwriters(underwriters: FirmUnderwriterItem[]): FirmUnderwriterItem[] {
  return underwriters.filter((underwriter) => !isUnderwriterLocked(underwriter));
}

export function getFilteredUnderwriters(
  underwriters: FirmUnderwriterItem[],
  searchQuery: string,
): FirmUnderwriterItem[] {
  const normalizedQuery = searchQuery.trim().toLowerCase();

  if (!normalizedQuery) {
    return underwriters;
  }

  return underwriters.filter((underwriter) => underwriter.Name.toLowerCase().includes(normalizedQuery));
}

export function getSelectAllState(
  selectableUnderwriters: FirmUnderwriterItem[],
  selectedIds: Set<number>,
): { allSelected: boolean; someSelected: boolean } {
  const allSelected =
    selectableUnderwriters.length > 0 && selectableUnderwriters.every((underwriter) => selectedIds.has(underwriter.Id));
  const someSelected = selectableUnderwriters.some((underwriter) => selectedIds.has(underwriter.Id));

  return { allSelected, someSelected };
}

export function toggleSelectAll(selectableUnderwriters: FirmUnderwriterItem[], selectedIds: Set<number>): Set<number> {
  const { allSelected } = getSelectAllState(selectableUnderwriters, selectedIds);
  const nextSelectedIds = new Set(selectedIds);

  if (allSelected) {
    selectableUnderwriters.forEach((underwriter) => {
      nextSelectedIds.delete(underwriter.Id);
    });
  } else {
    selectableUnderwriters.forEach((underwriter) => {
      nextSelectedIds.add(underwriter.Id);
    });
  }

  return nextSelectedIds;
}
